'use client';
import EcoImg, { EcoImgProps } from '../eco-img';
import EcoVideo, { EcoVideoProps } from '../eco-video';

export interface EcoImgVideoProps extends EcoVideoProps, EcoImgProps {
    /**
     * 是否是视频
     */
    isVideo?: boolean;
}

/**
 * 根据 isVideo 组合 EcoImg | EfVideo
 */
export default function EcoImgVideo({ isVideo = false, pc, h5, pad, autoPlay = true, loop = true, ...rest }: EcoImgVideoProps) {
    return (
        <>
            {!isVideo && <EcoImg pc={pc} h5={h5} pad={pad} {...rest} />}
            {isVideo && pc && <EcoVideo pc={pc} h5={h5} pad={pad} autoPlay={autoPlay} loop={loop} {...rest} />}
        </>
    );
}
